import history from '@/services/history'

import useService from '@/main/hooks/useService'

export const useOrder = ({ brokerData }) => {
  const goToNextStep = (orderId) => {
    history.push({
      pathname: '/recargas/pedido_recarga_broker/dados',
      state: { orderId },
    })
  }

  const [fetchLastOrderState, fetchLastOrderRequest] = useService(brokerData?.getLastOrder, {
    silent: true,
  })

  const [redoOrderState, redoOrderRequest] = useService(brokerData?.redoLastOrder, {
    onCompleted: (res) => goToNextStep(res.data),
  })

  return {
    fetchLastOrderState,
    fetchLastOrderRequest,
    redoOrderState,
    redoOrderRequest,
  }
}
